import React from 'react';
import { VAIR_ALREADY_CONNECTED_MESSAGE } from 'constants/vair';
import CloseIcon from 'svg/CloseIcon';
import { Button } from 'components/Button';
import Modal from 'components/modals/Modal';

interface VairConnectionStatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'success_login' | 'error';
}

const VairConnectionStatusModal: React.FC<VairConnectionStatusModalProps> = ({
  isOpen,
  onClose,
  type,
}) => {
  const isError = type === 'error';

  const title = isError ? 'Account Already Connected' : 'Successfully Connected';

  const message = isError
    ? VAIR_ALREADY_CONNECTED_MESSAGE
    : 'Your VAIR account has been successfully connected!';

  return (
    <Modal isOpen={isOpen} handleClose={onClose} classNameMaxWidth="md:max-w-[25rem] xs:max-w-md">
      <div className="flex flex-col justify-between gap-8 px-6 pb-5 pt-6">
        <div className="flex flex-row justify-between">
          <h3 className="typography-product-heading-compact  text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            {title}
          </h3>
        </div>
        <p className="typography-product-body font-normal text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          {message}
        </p>
        <div className="w-full">
          <Button variant="primary" className="w-full" size="lg" onClick={onClose}>
            Got it
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default VairConnectionStatusModal;
